import * as React from "react";
import { cn } from "@/lib/utils";

export function Badge({ className, ...props }: React.ComponentProps<"span">) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-md bg-sky-50 px-2 py-1 text-xs font-medium text-sky-900 ring-1 ring-inset ring-sky-100 dark:bg-sky-950 dark:text-sky-100 dark:ring-sky-900",
        className,
      )}
      {...props}
    />
  );
}
